// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SearchResultContextProperties = {
  arrival_time: string;
  journey_id: number;
  company: string;
  is_outbound: number;
  num_journeys?: number;
  departure_time: string;
  seats_left?: string;
  currency?: string;
  number_of_stops: number;
  selected_result_hour?: number;
  final_position_in_list?: number;
  is_live_updates?: boolean;
  price_in_cents?: number;
  time_to_select?: number;
  journey_labels?: string[];
  is_discount_card_applied?: boolean;
  price_euro_cents?: number;
  travel_mode: string;
  position_in_list?: number;
  duration_mn: number;
  tickets_left?: number;
  is_mobile_ticket?: boolean;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/search_result_context/jsonschema/2-0-0';
export const searchResultContextName = 'search_result_context';
export class SearchResultContext extends BaseTrackingContext<SearchResultContextProperties> {
  constructor(properties: SearchResultContextProperties) {
    super(searchResultContextName, schema, properties);
  }
}
